<div class="bk-modal__right-fertilizers__form">
	<form #f="ngForm" *ngIf="fertilizer">
		<div class="bk-modal__right-two-col bk-modal__right-two-col--left">
			<mat-form-field appearance="fill" class="mat-form-field--short">
				<mat-label>
					{{'Fertilizer Name' | translate }}
				</mat-label>
				<input matInput
					type="text"
					required
					name="Name"
					[(ngModel)]="fertilizer.Name"/>
				<mat-error *ngIf="formErrors.Name">
					{{ formErrors.Name | translate }}
				</mat-error>
			</mat-form-field>

			<mat-form-field appearance="fill"
				class="mat-form-field--one-line mat-form-field--short">
				<mat-label>
					{{'Fertilizer Type' | translate }}
				</mat-label>
				<mat-select required
					name='IsChemical'
					[(ngModel)]="fertilizer.IsChemical"
					(ngModelChange)="onFertilizerTypeChange($event)">
					<mat-option [value]="true">
						{{'Chemical' | translate }}
					</mat-option>
					<mat-option [value]="false">
						{{'Organic' | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<ng-container *ngIf="!fertilizer.IsChemical">
				<mat-form-field *ngIf="showMineralizationFields"
					appearance="fill"
					class="mat-form-field--one-line mat-form-field--short">
					<mat-label>
						{{'Nitrogen Unit' | translate }}
					</mat-label>
					<mat-select required
						name='NitrogenUnit'
						[(ngModel)]="fertilizer.OrganicFertilizer.NitrogenUnit">
						<mat-option [value]="1">
							{{'Material as received' | translate }}
						</mat-option>
						<mat-option [value]="2">
							{{'Dry matter' | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field appearance="fill" class="mat-form-field--short">
					<mat-label>
						{{'Total Nitrogen' | translate }}
					</mat-label>
					<input matInput
						type="number"
						required
						name="TotalNitrogen"
						[(ngModel)]="fertilizer.OrganicFertilizer.TotalNitrogen"/>
					<span matSuffix class="mat-form-field-suffix--padded">%
					</span>
				</mat-form-field>

				<mat-form-field appearance="fill" class="mat-form-field--short">
					<mat-label>
						{{'C:N Ratio' | translate }}
					</mat-label>
					<input matInput
						type="number"
						required
						name="CNRatio"
						[(ngModel)]="fertilizer.OrganicFertilizer.CNRatio"/>
				</mat-form-field>

				<ng-container *ngIf="showMineralizationFields">
					<mat-form-field appearance="fill" class="mat-form-field--short">
						<mat-label>
							{{'Mineral Nitrogen' | translate }}
						</mat-label>
						<input matInput
							type="number"
							required
							name="MineralNitrogen"
							[(ngModel)]="fertilizer.OrganicFertilizer.MineralNitrogen"/>
						<span matSuffix class="mat-form-field-suffix--padded">%
						</span>
					</mat-form-field>

					<mat-form-field *ngIf="fertilizer.OrganicFertilizer.NitrogenUnit === 2"
						appearance="fill" class="mat-form-field--short">
						<mat-label>
							{{'Dry Matter %' | translate }}
						</mat-label>
						<input matInput
							type="number"
							required
							name="DryMatter"
							[(ngModel)]="fertilizer.OrganicFertilizer.DryMatter"/>
					</mat-form-field>

					<mat-form-field appearance="fill" class="mat-form-field--short">
						<mat-label>
							{{'Fast FOM' | translate }}
						</mat-label>
						<input matInput
							type="number"
							required
							name="FOMFastFraction"
							[(ngModel)]="fertilizer.OrganicFertilizer.FOMFastFraction"/>
						<span matSuffix class="mat-form-field-suffix--padded">%
						</span>
					</mat-form-field>

					<mat-form-field appearance="fill" class="mat-form-field--short">
						<mat-label>
							{{'Decomposition rate (fast)' | translate }}
						</mat-label>
						<input matInput
							type="number"
							required
							name="DecompositionRateFast"
							[(ngModel)]="fertilizer.OrganicFertilizer.DecompositionRateFast"/>
					</mat-form-field>

					<mat-form-field appearance="fill" class="mat-form-field--short">
						<mat-label>
							{{'Decomposition rate (slow)' | translate }}
						</mat-label>
						<input matInput
							type="number"
							required
							name="DecompositionRateSlow"
							[(ngModel)]="fertilizer.OrganicFertilizer.DecompositionRateSlow"/>
					</mat-form-field>
				</ng-container>
			</ng-container>

			<mat-form-field appearance="fill"
				class="mat-form-field--one-line mat-form-field--short">
				<mat-label>
					{{'Formulation' | translate }}
				</mat-label>
				<mat-select required
					name='formulationTypeId'
					[(ngModel)]="fertilizer.FormulationTypeId">
					<mat-option [value]="1">
						{{'Dry' | translate }}
					</mat-option>
					<mat-option [value]="2">
						{{'Wet' | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<ng-container *ngIf="fertilizer.FormulationTypeId === formulationTypes.WET">
				<mat-form-field appearance="fill" class="mat-form-field--short">
					<input matInput
						type="number"
						step="0.01"
						required
						name='PoundsPerGallon'
						[(ngModel)]="fertilizer.PoundsPerGallon"/>
					<span matSuffix class="mat-form-field-suffix--padded">
						{{'lbs' | translate}}/{{'gal' | translate}}
					</span>
					<mat-error *ngIf="formErrors.PoundsPerGallon">
						{{ formErrors.PoundsPerGallon | translate }}
					</mat-error>
				</mat-form-field>
			</ng-container>
		</div>

		<div class="bk-modal__section" *ngIf="fertilizer.IsChemical">
			<h4 class="bk-modal__section-title">
				{{'Nutrient' | translate }}
			</h4>

			<div class="bk-modal__nutrients-group">
				<div class="bk-model__nutrients-item"
					*ngFor="let nutrient of fertilizer.Nutrients">

					<mat-form-field appearance="fill" class="mat-form-field--three-wide">
						<mat-label>
							{{nutrient.Name}}
						</mat-label>

						<input matInput
							type="number"
							step="0.01"
							size="2"
							[minNumber]="0"
							[maxNumber]="100"
							required
							name="Nutrient{{nutrient.NutrientId}}"
							[(ngModel)]="nutrient.Percentage"/>
						<span matSuffix class="mat-form-field-suffix--padded">
							%
						</span>
					</mat-form-field>
				</div>
			</div>

			<h4 [class.bk-text--error]="nutrientTotalPercentage.validationError !== null"
				class="bk-clearfix">
				{{'Total Nutrients' | translate }}: {{nutrientTotalPercentage.total}}%
			</h4>

			<div *ngIf="nutrientTotalPercentage.validationError === validationErrors.TOTAL_TOO_BIG"
				class="bk-invalid-text--nutrient bk-invalid">
				{{'Total cannot exceed 100%' | translate }}
			</div>
			<div *ngIf="nutrientTotalPercentage.validationError === validationErrors.TOTAL_NOT_GREATER_THAN_ZERO"
				class="bk-invalid-text--nutrient bk-invalid">
				{{'Total must be greater than 0%' | translate }}
			</div>
		</div>
	</form>
</div>